// src/services/translation.js (为你的调用方式优化)

const API_BASE = 'http://127.0.0.1:5000';

function containsZh(str) {
	return str && typeof str === 'string' && str.toLowerCase().includes('zh');
}

/**
 * 专为你的调用模式优化的翻译函数
 * 成功时返回标准化结果，失败时抛出错误（以便catch捕获）
 * @param {string} text - 要翻译的文本
 * @param {boolean} getAlternatives - 是否获取备选翻译
 * @returns {Promise<Object>} 成功时返回结果对象，失败时抛出错误
 */
export function translateToChinese(text, getAlternatives = false) {
	// 参数验证
	if (!text || typeof text !== 'string' || text.trim() === '') {
		return Promise.reject(new Error('翻译文本不能为空'));
	}

	// 使用Promise链式调用，确保失败时进入catch
	return fetch(`${API_BASE}/translate`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				q: text,
				source: 'auto',
				target: 'zh',
				format: 'text',
				alternatives: getAlternatives,
			}),
		})
		.then(response => {
			// HTTP状态码错误处理
			if (!response.ok) {
				return response.json()
					.then(errorData => {
						// 抛出错误，确保进入catch块
						throw new Error(`翻译失败: ${errorData.error || `HTTP ${response.status}`}`);
					})
					.catch(() => {
						throw new Error(`翻译失败: HTTP ${response.status}`);
					});
			}
			return response.json();
		})
		.then(data => {
			// 成功时返回标准化的结果对象
			return {
				success: true,
				original: text,
				translated: data.translatedText || '', // 确保有translated字段
				detectedLanguage: containsZh(data.detectedLanguage?.language || 'unknown'),
				confidence: data.detectedLanguage?.confidence || 0,
				alternatives: data.alternatives || [],
				raw: data, // 原始响应
			};
		})
	// 注意：这里不捕获错误，让错误冒泡到调用者的catch
}